export class QueHacemos {
  id?: string;
  fechaCreacion?: string;
  image?: string;
  imageName?: string;
  publicado?: boolean;
  descripcion?: string;
  titulo?: string;
}
